import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { NewIconN } from './icons';
import { StyledButton, StyledImg, StyledText } from './styledCommandPanelButton';

const StyledNewButton = styled(StyledButton)`
  height: 2.5em;
`;

export function NewButton({ content, onClick, disabled }) {
  return (
    <StyledNewButton onClick={onClick} disabled={disabled} title={content}>
      <StyledImg style={{ width: '20px' }} src={NewIconN} alt={content} />
      <StyledText>{content}</StyledText>
    </StyledNewButton>
  );
}

NewButton.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
};

NewButton.defaultProps = {
  onClick: () => null,
  content: 'Створити',
  disabled: false,
};

export default NewButton;
